<template>
  <div class="centerItem">
    <div style="text-align: center;">
      <div style="font-size: 16px;line-height: 30px; padding-bottom: 10px;">站点：{{this.normalMarkData.length + this.exceptionMarkData.length}}</div>
      <dv-decoration-3 style="width:250px;height:10px;margin: auto" />
    </div>
    <div class="goback flex" v-if="pathData.length > 0"><i class="goback_icon" @click="goBack"></i></div>
    <div id="mapChart" ref="mapChart" style="width:100%;height:100%;"></div>
    <Drawer title="站点信息" :closable="false" v-model="showDrawer" class="siteInfo">
      <h2 class="site-h2">{{siteInf.siteName}}</h2>
      <ul class="site-ul">
        <li v-for="item in siteInf.collectParamterList">
          <label>{{item.collectionParameterName}}</label>
          {{item.realData}}{{item.unitCode}}
        </li>
      </ul>
    </Drawer>
  </div>

</template>
<script>
  import echarts from "echarts";
  import {siteInfo} from "@/api/Map.js";
  export default {
    name: "mapChart",
    components: {},
    props: {
      markData: {
        type: [Object, Array],
        default: () => {
        }
      },
      width: {
        type: String,
        default: "100%"
      },
      height: {
        type: String,
        default: "100%"
      }

    },

    data() {
      return {
        chart: null,
        cityName: "中国",
        areaCode: 10000,
        geoJsonData: "",
        map: null,
        district: null,
        // count: 0,
        opts: {},
        areaData: {},
        mapData: [],
        codeList: [],
        // markData: {}
        pathData: [],
        normalMarkData: [],
        exceptionMarkData: [],
        siteInf: {},
        showDrawer: false
      };
    },
    mounted() {
      // 自适应
      window.addEventListener("resize", () => {
        if (this.chart) this.chart.resize();
      });
    },
    watch: {
      markData(val) {
        console.log(val)
        if (val) {
          this.$nextTick(function () {
            this.initChart(100000);
          });
        }
      }
    },
    methods: {
      initChart(adcode, region) {
        this.chart = echarts.init(this.$refs.mapChart);
        this.chart.on("click", this.chartClick);
        this.opts = {
          subdistrict: 1, //返回下一级行政区
          showbiz: false //最后一级返回街道信息
        };
        this.district = new AMap.DistrictSearch(this.opts); //注意：需要使用插件同步下发功能才能这样直接使用
        this.district.search(adcode, (status, result) => {
          if (status == "complete") {
            this.getData(
              result.districtList[0],
              result.districtList[0].level,
              result.districtList[0].adcode,
              false,
              region
            );
          }
        });
      },

      getData(data, level, adcode, click, region) {
        //重庆分为城区和郊区  需要合并数据
        if (data.adcode == "500100") {
          this.district.search("500200", (status, result) => {
            if (status === "complete") {
              subList = subList.concat(result.districtList[0].districtList);
              this.mapData = [];
              for (var i = 0, l = subList.length; i < l; i++) {
                var name = subList[i].name;
                var cityCode = subList[i].adcode;
                this.mapData.push({
                  name: name,
                  cityCode: cityCode,
                  level: curlevel
                });
              }

              this.loadMapData(adcode, "", level);
              return;
            }
          });
        }
        var subList = data.districtList;
        if (subList) {
          var curlevel = subList[0].level;
          if (curlevel === "street") {
            if (region) {
              this.loadMapData(adcode, region, level);
            } else {
              let mapJsonList = this.geoJsonData.features;
              let mapJson = {};
              for (let i in mapJsonList) {
                if (mapJsonList[i].properties.name == this.cityName) {
                  mapJson.features = [].concat(mapJsonList[i]);
                }
              }
              this.mapData = [];
              this.mapData.push({
                name: this.cityName,
                cityCode: adcode,
                level: curlevel
              });
              this.loadMap(this.cityName, mapJson, level);
            }
            // 改变下拉框
            if (click) {
              //区分是点击事件才执行，不然会与下拉框选择事件一起触发
              let params = {
                level: level,
                adcode: adcode
              };
              this.$emit("clickMap", params);
            }
            return;
          }
          this.mapData = [];
          for (var i = 0, l = subList.length; i < l; i++) {
            var name = subList[i].name;
            var cityCode = subList[i].adcode;
            this.mapData.push({
              name: name,
              cityCode: cityCode,
              level: curlevel
            });
          }

          this.loadMapData(adcode, "", level);
          // 改变下拉框
          if (click) {
            let params = {
              level: level,
              adcode: adcode
            };
            this.$emit("clickMap", params);
          }
        }
      },
      loadMapData(areaCode, region, level) {
        AMapUI.loadUI(["geo/DistrictExplorer"], DistrictExplorer => {
          //创建一个实例
          var districtExplorer = (window.districtExplorer = new DistrictExplorer({
            eventSupport: true, //打开事件支持
            map: this.map
          }));
          //  行政区划浏览的直辖市等级为北京市=》朝阳区，并不是北京市=》北京城区=》朝阳区 所以需要转化
          if (areaCode == "110100") {
            areaCode = "110000";
          } else if (areaCode == "120100") {
            areaCode = "120000";
          } else if (areaCode == "500100" || areaCode == "500200") {
            areaCode = "500000";
          } else if (areaCode == "310100") {
            areaCode = "310000";
          }
          districtExplorer.loadAreaNode(areaCode, (error, areaNode) => {
            if (error) {
              console.log("报错啦");
              return;
            }
            if (areaNode) {
              // 次级页面直接显示区县 需要单独处理;
              if (region) {
                let mapJson = {
                  features: []
                };
                mapJson.features[0] = areaNode.getParentFeature();
                this.loadMap(mapJson.features[0].properties.name, mapJson, level);
                this.geoJsonData = mapJson;
              } else {
                let mapJson = {};
                mapJson.features = areaNode.getSubFeatures();
                this.loadMap(this.cityName, mapJson, level);
                this.geoJsonData = mapJson;
              }
            }
          });
        });
      },
      loadMap(mapName, data, level) {
        let symbolSize = 8;
        let normalShow = false;
        if (level == "province") {
          symbolSize = 10;
        } else if (level == "city") {
          symbolSize = 12;
        } else if (level == "district") {
          symbolSize = 14;
          normalShow = true;
        } else {
          this.normalMarkData = this.markData.normal;
          this.exceptionMarkData = this.markData.exception;
        }

        if (data) {
          echarts.registerMap(mapName, data);
          var option = {
            legend: {
              orient: "horizontal",
              x: "left",
              data: ["正常", "异常"],
              textStyle: {
                color: "#fff"
              }
            },
            geo: {
              map: mapName,
              roam: false,
              // aspectScale:1,
              zoom: 1.2, //缩放
              label: {
                emphasis: {
                  show: true,
                  color: "#fff"

                }
              },
              itemStyle: {
                normal: {
                  borderColor: "rgba(100,149,237,1)",
                  borderWidth: 1,
                  areaColor: "rgb(49,31,181)",
                  label: {
                    show: false,
                    textStyle: {
                      color: "rgb(249, 249, 249)"
                    }
                  }
                },
                emphasis: {
                  areaColor: "rgba(62,21,114,.5)",
                  label: {
                    show: true,
                    textStyle: {
                      color: "#fff"
                    }
                  }
                }
              },
            },
            series: [
              {
                name: '正常',
                type: 'effectScatter',
                coordinateSystem: 'geo',
                data: this.normalMarkData,
                symbolSize: symbolSize,
                legendHoverLink:true,       //是否启用图例 hover 时的联动高亮。
                hoverAnimation:true,        //是否开启鼠标 hover 的提示动画效果。
                effectType:"ripple",        //特效类型，目前只支持涟漪特效'ripple'。
                showEffectOn:"render",      //配置何时显示特效。可选：'render' 绘制完成后显示特效。'emphasis' 高亮（hover）的时候显示特效。
                rippleEffect:{              //涟漪特效相关配置。
                  period:4,               //动画的时间。
                  scale:2.5,              //动画中波纹的最大缩放比例。
                  brushType:'stroke',      //波纹的绘制方式，可选 'stroke' 和 'fill'。
                },
                label: {
                  normal: {
                    show: normalShow,
                    formatter: function (param) {
                      return param.data.name;
                    },
                    color: "rgb(255, 255, 255)",
                    position: 'top',
                  },
                  emphasis: {
                    show: true,
                    formatter: function (param) {
                      return param.data.name;
                    },
                    color: "rgb(255, 255, 255)",
                    position: 'top',
                  },
                },
                itemStyle: {
                  normal: {
                    color: '#1ddcdd'
                  },
                  emphasis: {
                    // borderColor: '#fff',
                    // borderWidth: 1
                  }
                },

              },
              {
                name: '异常',
                type: 'effectScatter',
                coordinateSystem: 'geo',
                data: this.exceptionMarkData,
                symbolSize: symbolSize,
                legendHoverLink:true,       //是否启用图例 hover 时的联动高亮。
                hoverAnimation:true,        //是否开启鼠标 hover 的提示动画效果。
                effectType:"ripple",        //特效类型，目前只支持涟漪特效'ripple'。
                showEffectOn:"render",      //配置何时显示特效。可选：'render' 绘制完成后显示特效。'emphasis' 高亮（hover）的时候显示特效。
                rippleEffect:{              //涟漪特效相关配置。
                  period:4,               //动画的时间。
                  scale:3,              //动画中波纹的最大缩放比例。
                  brushType:'stroke',      //波纹的绘制方式，可选 'stroke' 和 'fill'。
                },
                label: {
                  normal: {
                    show: normalShow,
                    formatter: function (param) {
                      return param.data.name;
                    },
                    color: "rgb(255, 255, 255)",
                    position: 'top',
                  },
                  emphasis: {
                    show: true,
                    formatter: function (param) {
                      return param.data.name;
                    },
                    color: "rgb(255, 255, 255)",
                    position: 'top',
                  },
                },
                itemStyle: {
                  // emphasis: {
                  //   borderColor: '#fff',
                  //   borderWidth: 1
                  // }
                },

              },
            ]
          };
          this.chart.setOption(option);
        }
      },
      getClickData(name) {
        for (let i = 0; i < this.mapData.length; i++) {
          if (name == this.mapData[i].name) {
            return {name: this.mapData[i].name, cityCode: this.mapData[i].cityCode, level: this.mapData[i].level};
          }
        }
      },

      //地图点击事件
      chartClick(params) {
        let that = this;
        // 点击标注区域进入下一个页面，否则进入地图下钻
        if (params.componentType == "series") {
          siteInfo(params.data.id, res => {
            if (res.data.errcode == 0){
              this.siteInf = res.data.body;
              this.showDrawer = true;
            }
          });



        } else {
          if (params.data == undefined) {
            params.data = this.getClickData(params.name)
          }
          if (params.data.level == "street") return;
          if (this.pathData.length == 0 ||
            (this.pathData.length > 0 && this.pathData[this.pathData.length - 1].data.cityCode != params.data.cityCode)) {
            this.pathData.push(params);
          }
          let length = 0;
          if (params.data.level == "province") {
            length = 2;
          } else if (params.data.level == "city") {
            length = 4;
          } else if (params.data.level == "district") {
            length = 6;
          }
          this.normalMarkData = [];
          for (let i = 0; i < this.markData.normal.length; i++) {
            if (params.data.cityCode.substr(0, length) == this.markData.normal[i].adcode.substr(0, length)) {
              this.normalMarkData.push(this.markData.normal[i]);
            }
          }
          this.exceptionMarkData = [];
          for (let i = 0; i < this.markData.exception.length; i++) {
            if (params.data.cityCode.substr(0, length) == this.markData.exception[i].adcode.substr(0, length)) {
              this.exceptionMarkData.push(this.markData.exception[i]);
            }
          }

          this.cityName = params.data.name;
          this.cityCode = params.data.cityCode;
          this.district.setLevel(params.data.level); //行政区级别
          this.district.setExtensions("all");
          //行政区查询，按照adcode进行查询可以保证数据返回的唯一性
          this.district.search(this.cityCode, (status, result) => {
            if (status === "complete") {
              let adcode = result.districtList[0].districtList[0].adcode;
              //如果是直辖市（北京、天津、重庆、上海）还需要再检索一边 市=》城区=》区  与常规省=》市=》区 格式一致
              if (
                adcode == "110100" ||
                adcode == "500100" ||
                adcode == "500200" ||
                adcode == "120100" ||
                adcode == "310100"
              ) {
                this.district.search(adcode, (status, result) => {
                  if (status === "complete") {
                    this.getData(
                      result.districtList[0],
                      params.data.level,
                      this.cityCode,
                      "click"
                    );
                  }
                });
              } else {
                this.getData(
                  result.districtList[0],
                  params.data.level,
                  this.cityCode,
                  "click"
                );
              }
            }
          });
        }
      },
      goBack() {
        if (this.pathData.length == 1) {
          this.initChart(10000, "region");
          this.pathData = [];
        } else {
          this.pathData.pop();
          console.log(this.pathData)
          this.chartClick(this.pathData[this.pathData.length - 1]);
        }
      },

    }
  };
</script>

<style lang="scss">
  .centerItem {
    height: 100%;
    width: 100%;
  }

  .goback {
    width: 64px;
    height: 64px;
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 1;
    justify-content: center;
    align-items: center;
  }

  .goback .goback_icon {
    width: 32px;
    height: 32px;
    display: block;
    background: url(../../static/image/returnbtn-icon.png) no-repeat;
    background-size: cover;
  }

  .goback:hover {
    cursor: pointer;
  }
  .siteInfo li {
    padding: 5px;
    font-size: 14px;
    color: #333;
  }
  .site-h2{
    /*border-left: 5px solid #25d2e8;*/
    /*padding-left: 10px;*/
    /*border-bottom: 1px solid #eee;*/
    margin-bottom: 10px;
    color: #1985e9;
    text-align: center;
  }
  .site-ul{
    li{
      label{
        display: inline-block;
        width: 100px;
      }
    }
    li:nth-child(2n-1){
      background: #f5f5f5;
    }
  }
</style>
